<app-layout>
  <div class="px-[0.88rem] md:pt-[4.5rem]" primary>
    @if (response) {
      @if (
        response.surveyTitle &&
        response.responseId !== "00000000-0000-0000-0000-000000000000"
      ) {
        <h1
          class="font-normal text-[2.5rem] title-dynamic-theme mb-6"
          [innerHTML]="response.surveyTitle | safeHtml"
        ></h1>
      }
    }

    @if (informationView) {
      @if (informationView.data.componentType === "EDIT_REPONSE_COMPLETED") {
        <div class="flex flex-col items-center justify-center my-12">
          <img
            src="assets/icons/check-circle.svg"
            alt="Success"
            width="80"
            height="80"
            class="mb-6"
          />
          <div class="text-xl font-semibold text-center">
            {{ "editresponse.saved.message" | translate }}
          </div>
        </div>
      } @else {
        @if (
          informationView.data.translationKeyBody || informationView.data.message
        ) {
          <div
            [innerHTML]="
              (informationView.data.translationKeyBody
                | translate
                | translationTags
                  : informationView.data.translationTags
                  : selectedLanguage) || informationView.data.message | safeHtml
            "
          ></div>
        }
      }

      @for (component of informationView.data.components; track $index) {
        @if (component.componentType === "INFORMATION") {
          @if (
            informationView.data.componentType === "THANKYOU_INFORMATION" &&
            !component.message
          ) {
            <div>{{ "thankyou.defaulttext" | translate }}</div>
          } @else if (
            informationView.data.componentType === "THANKYOU_CUSTOM_INFORMATION"
          ) {
            @if (
              response &&
              response.responseId === "00000000-0000-0000-0000-000000000000"
            ) {
              <h1
                class="font-normal text-[2.5rem] title-dynamic-theme mb-6"
                [innerHTML]="response.surveyTitle | safeHtml"
              ></h1>
            }
            @if (!component.message) {
              <div>{{ component.translationKeyBody | translate }}</div>
            }
          }
          <div
            class="rich-text-content"
            [innerHTML]="component.message | safeHtml"
          ></div>
        }
      }

      @for (component of informationView.data.components; track $index) {
        @if (component.componentType === "COLLECT_EMAIL") {
          <div class="mt-10">
            <form>
              <label class="text-base" for="email-collect">
                {{ "information.collectemail.text" | translate }}
              </label>
              <input
                id="email-collect"
                name="email-collect"
                type="email"
                autocomplete="email"
                [formControl]="emailCollectControl"
                class="w-full bg-[initial] focus:outline"
                [attr.aria-describedby]="getEmailCollectAriaDescribedBy()"
                [attr.aria-invalid]="
                  emailCollectControl.invalid && emailCollectControl.touched
                "
                [attr.aria-required]="true"
              />
              <div class="min-h-1">
                @if (
                  !emailCollectControl.value && emailCollectControl.touched
                ) {
                  <div
                    role="alert"
                    aria-live="assertive"
                    id="email-collect-empty-error"
                  >
                    <app-icon
                      [name]="Icon.Warning"
                      aria-hidden="true"
                      class="relative float-right bottom-[2.3rem] right-1 validation-dynamic-theme"
                    ></app-icon>
                    <app-validator [validator]="validator.EmptyEmailCollect" />
                  </div>
                } @else if (
                  emailCollectControl.invalid && emailCollectControl.touched
                ) {
                  <div
                    role="alert"
                    aria-live="assertive"
                    id="email-collect-invalid-error"
                  >
                    <app-icon
                      [name]="Icon.Warning"
                      aria-hidden="true"
                      class="relative float-right bottom-[2.3rem] right-1 validation-dynamic-theme"
                    ></app-icon>
                    <app-validator
                      [validator]="validator.InvalidEmailCollect"
                    />
                  </div>
                }
              </div>
            </form>
          </div>
        }
      }

      @for (component of informationView.data.components; track $index) {
        @if (component.componentType === "HIDDEN_INFORMATION") {
          <div class="mt-6 mb-24">
            @switch (component.hidden) {
              @case (true) {
                <div>
                  <p>{{ "welcome.hiddenidentity.hidden.title" | translate }}</p>
                  <br />
                  <p>{{ "welcome.hiddenidentity.information" | translate }}</p>
                </div>
              }
              @case (null) {
                <div>
                  <div
                    class="lg:hover:font-bold flex items-center mb-3 qb-checkbox-outline qb-checkbox transition-transform-slow lg:hover:scale-[1.02]"
                  >
                    <input
                      type="checkbox"
                      id="hiddenIdentity"
                      name="hiddenIdentity"
                      [(ngModel)]="hiddenIdentityRequest"
                      [attr.aria-describedby]="
                        getHiddenIdentityAriaDescribedBy()
                      "
                      [attr.aria-invalid]="hasHiddenIdentityError()"
                      [attr.aria-required]="isHiddenIdentityRequired()"
                    />
                    <label for="hiddenIdentity" class="ml-1 cursor-pointer">
                      {{ "welcome.hiddenidentity.optional.title" | translate }}
                    </label>
                  </div>
                  <p id="hiddenIdentityDescription">
                    {{ "welcome.hiddenidentity.information" | translate }}
                  </p>
                </div>
              }
            }
            @for (item of error$ | async; track item) {
              @if (
                item.translationKey === "validation.general.missinghiddenanswer"
              ) {
                <div
                  id="hiddenIdentityError"
                  role="alert"
                  aria-live="assertive"
                >
                  <app-validator [validator]="validator.HiddenAnswerMissing" />
                </div>
              }
            }
          </div>
        }
      }

      @for (component of informationView.data.components; track $index) {
        @if (component.componentType === "SEND_RECEIPT") {
          @if (showEmailReceiptInput) {
            <div class="mt-10">
              <form>
                <label class="text-base" for="email-receipt">
                  {{ "thankyou.sendreceipt.copytoemailaddress" | translate }}
                </label>
                <input
                  id="email-receipt"
                  name="email-receipt"
                  type="email"
                  autocomplete="email"
                  [formControl]="emailReceiptControl"
                  class="w-full bg-[initial] focus:outline"
                  [attr.aria-describedby]="getEmailReceiptAriaDescribedBy()"
                  [attr.aria-invalid]="
                    emailReceiptControl.invalid && emailReceiptControl.touched
                  "
                />
                <div class="min-h-16">
                  @if (
                    emailReceiptControl.invalid && emailReceiptControl.touched
                  ) {
                    <div
                      role="alert"
                      aria-live="assertive"
                      id="email-receipt-error"
                    >
                      <app-icon
                        [name]="Icon.Warning"
                        aria-hidden="true"
                        class="relative float-right bottom-[2.3rem] right-1 validation-dynamic-theme"
                      ></app-icon>
                      <app-validator
                        [validator]="validator.InvalidEmailReceipt"
                      />
                    </div>
                  } @else {
                    @for (item of error$ | async; track item) {
                      @if (
                        item.translationKey ===
                        "validation.responsereceipt.receipthasalreadybeensent"
                      ) {
                        <div role="alert" aria-live="assertive">
                          <app-validator
                            [validator]="validator.ReceiptHasAlreadyBeenSent"
                          />
                        </div>
                      }
                    }
                  }
                </div>
                <div>
                  <app-button
                    [disabled]="
                      emailReceiptControl.invalid || !emailReceiptControl.value
                    "
                    (buttonClick)="onSendEmailSubmit()"
                    buttonId="receipt-btn"
                    [buttonText]="'thankyou.sendreceipt.button' | translate"
                    [description]="'thankyou.sendreceipt.button' | translate"
                    type="submit"
                    customClasses="h-[46px] w-fit justify-center"
                  >
                  </app-button>
                </div>
              </form>
            </div>
          } @else {
            <div class="mt-10 mb-44" role="status" aria-live="polite">
              {{ "thankyou.sendreceipt.emailissent" | translate }}
            </div>
          }
        }
      }

      @if (informationView.data.componentType === "GDPR_DECLINED_INFORMATION") {
        <div class="font-normal text-[1.5rem] text-inherit mb-6">
          {{ "gdpr.statement.notparticipate.receiptheader" | translate }}
        </div>
        <div>
          {{ "gdpr.statement.notparticipate.receiptcontent" | translate }}
        </div>
      }
    }
  </div>

  @if (
    response.view.data.componentType !== "THANKYOU_INFORMATION" &&
    response.view.data.componentType !== "THANKYOU_CUSTOM_INFORMATION" &&
    response.view.data.componentType !== "GDPR_DECLINED_INFORMATION" &&
    response.view.data.componentType !== "EDIT_REPONSE_COMPLETED" &&
    response.responseId !== "00000000-0000-0000-0000-000000000000"
  ) {
    <app-navigation
      (nextClick)="next()"
      [nextButtonText]="'navigation.next.button' | translate"
      navigation
    ></app-navigation>
  }

  @if (chooseLanguageComponent) {
    <app-choose-language
      appLanguage
      class="mr-2 lg:mr-4"
      [showFlags]="chooseLanguageComponent.showFlags"
      (selectedLanguage)="setLanguage($event)"
      [defaultLanguage]="response.language"
      [options]="languageOptions"
      [translationKeys]="informationPageTranslationkeys"
      [fallbackLanguage]="response.fallbackLanguage"
    ></app-choose-language>
  }
</app-layout>
